import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

const client = axios.create({
  baseURL: API,
  headers: { "Content-Type": "application/json" },
});

export const fetchProducts = (params = {}) => client.get("/products", { params }).then((r) => r.data);
export const fetchProduct = (slug) => client.get(`/products/${slug}`).then((r) => r.data);

export const createCheckoutSession = (payload) =>
  client.post("/checkout/session", payload).then((r) => r.data);

export const getCheckoutStatus = (sessionId) =>
  client.get(`/checkout/status/${sessionId}`).then((r) => r.data);

export const subscribeNewsletter = (payload) =>
  client.post("/newsletter/subscribe", payload).then((r) => r.data);

export const submitContact = (payload) =>
  client.post("/contact", payload).then((r) => r.data);

export const formatPrice = (price, currency = "EUR") =>
  new Intl.NumberFormat("en-US", { style: "currency", currency }).format(price);

export default client;
